// libraries
import React from 'react'
import clsx from 'clsx'

// prop types
export interface Props {
    text?: string
    align?: 'left' | 'center' | 'right'
    externallink?: string
    small?: boolean
    color?: 'primary' | 'secondary' | 'tertiary'
    className?: string
    target?: '_blank' | '_self'
}

export default function RedButton({
    text,
    align = 'left',
    externallink,
    small,
    color,
    className,
    target = '_self'
}: Props) {

    // Don't render if there's no text
    if (!text || text.trim().length === 0) {
        return null
    }

    return (
        <a 
            href={externallink}
            className={clsx(
                'red-button',
                `red-button--align-${align}`,

                // colors
                color === 'primary' && 'red-button--primary',
                color === 'secondary' && 'red-button--secondary',
                color === 'tertiary' && 'red-button--tertiary',

                // sizes
                small && 'red-button--small',

                className
            )}
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : ''}
            dangerouslySetInnerHTML={{ __html: text }} 
            suppressHydrationWarning
        />
    )
}